import { colors, fonts, radius } from '../../theme/tokens'
import { choice, choiceOn } from '../choice-look'

// Day chips: two rows of six, equal columns edge to edge of whatever holds
// them. Equal weight for every day (no smaller or greyed early days), 44px
// tall at least.
export const styles = theme => ({
  // Full width wherever it sits: the pay panel holds it in a wrapping flex
  // row, where it shrank to its chips and stopped short of the size cards'
  // right edge (Robin's screenshot, 25 Oct 2026).
  // flex 1 1 100% and stretch too, so a flex row or column parent cannot
  // shrink it either (CI, 26 Oct 2026).
  root: { position: 'relative', width: '100%', minWidth: 0, flex: '1 1 100%', alignSelf: 'stretch' },
  title: {
    display: 'block',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontWeight: 500,
    fontSize: '0.75rem',
    color: '#64748b',
    marginBottom: 8
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
    // The pay panel's size cards' gap, so the two read as one block.
    gap: 8
  },
  gridCompact: {},
  // The booking screen's one chosen look (components/choice-look.js): the
  // green tint and a 2px green border once chosen. No fade.
  chip: {
    ...choice,
    borderRadius: radius.control,
    minHeight: 52,
    minWidth: 0,
    padding: '6px 2px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    fontFamily: fonts.body,
    // A day the district's availability rules out (lib/availability.js).
    '&:disabled': { opacity: 0.45, cursor: 'default' }
  },
  chipOn: choiceOn,
  chipInvalid: { borderColor: colors.error },
  // Today says "Same-day priority +£25": a row of its own, the words side by
  // side. Two columns (17 Oct 2026) left the twelve days a ragged last row of
  // two, and the words spilled out of a 390px phone's chip (26 Oct 2026).
  chipToday: { gridColumn: '1 / -1', flexDirection: 'row', gap: 8 },
  priority: { fontSize: 11, lineHeight: '14px', fontWeight: 600, color: colors.ink, whiteSpace: 'nowrap' },
  chipMore: { gridColumn: 'span 2' },
  weekday: { fontSize: 11, lineHeight: '14px', color: colors.mute, fontWeight: 500 },
  day: { fontSize: 15, lineHeight: '18px', fontWeight: 600, whiteSpace: 'nowrap' },
  // "Nov" after "1": smaller, so "1 Nov" fits a 390px phone's chip.
  month: { fontSize: 11, fontWeight: 600, letterSpacing: '-0.01em' },
  more: { fontSize: 13, fontWeight: 600, color: colors.accent },
  // "More dates": the chip, and the native date box over it, unseen, so a
  // tap lands on the box and the phone opens its own calendar (25 Oct 2026,
  // components/day-chips).
  moreWrap: { position: 'relative', minWidth: 0, display: 'flex' },
  moreChip: { width: '100%' },
  moreInput: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    border: 0,
    opacity: 0,
    cursor: 'pointer',
    // 16px: iOS zooms the page into a focused box with smaller text.
    fontSize: 16,
    WebkitAppearance: 'none',
    appearance: 'none',
    background: 'transparent',
    zIndex: 1
  },
  error: {
    margin: '6px 0 0',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 13,
    fontWeight: 500,
    color: '#dc2626'
  },
  hint: {
    margin: '6px 0 0',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: '#64748b'
  },
  sameDayNote: {
    margin: '8px 0 0',
    padding: '6px 10px',
    background: '#fffbeb',
    border: '1px solid #fde68a',
    borderRadius: 8,
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 12,
    color: '#92400e'
  }
})
